import React from 'react'
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { MuiDrawer, styled, Box } from '../../../theme/MUIImports';
import { AlertDialog, Button, CreateDomainForm } from '../..';
import { AdminSideMenus } from './admin/AdminSideMenus';
import { UserSideMenu } from './user/UserSideMenu';
import { useStyles } from './SidebarStyles';
import { ManagerSideMenus } from './manager';
import { getConfig } from '../../../utils/config';

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open, drawerwidth }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerwidth,
      backgroundColor: theme.palette.primary.main,
      height: "100vh",
      boxSizing: 'border-box',
    },
  }),
);

export const Sidebar = ({ 
  open = false, 
  drawerWidth = 240, 
  navigate = () => null, 
  location = {}, 
  role = "", 
  handleOpenSnackMessage = () => null 
}) => {
  const classes = useStyles()
  const { sideMenu, selectedNamespace } = useSelector(state => state.user)

  const [isOpenPopup, setOpenPopup] = React.useState({
    open: false,
    children: null,
    handleNo: null
  })

  // Determine isTestMode value using IIFE to keep it as const
  const isTestMode = (() => {
    try {
      const cfg = getConfig();
      return cfg?.enableTestMode === true;
    } catch (_) {
      // runtime config not yet loaded; use public fallback
      // Fallback to build-time environment variable
      return process.env.REACT_APP_ENABLE_TEST_MODE === 'true';
    }
  })();

  // Build logo URL from runtime config; fallback to public asset
  let logoSrc = "/mecha-logo.png";
    try {
    const cfg = getConfig();
    if (cfg?.awsImageBaseUrl && cfg?.s3BucketVersion) {
      logoSrc = `${cfg.awsImageBaseUrl}/${cfg.s3BucketVersion}/mecha-logo.png`;
    }
  } catch (_) {
    // runtime config not yet loaded; use public fallback
  }

  //close enter domain and jira ticket details popup
  const closeCreateJiraTicketPopup = () => setOpenPopup({ ...isOpenPopup, open: false })

  //open enter domain and jira ticket details popup
  const openCreateJiraTicketPopup = () => setOpenPopup({
    ...isOpenPopup, open: true, handleNo: closeCreateJiraTicketPopup,
    children: <CreateDomainForm 
      navigate={navigate} 
      location={location} 
      handleOpenSnackMessage={handleOpenSnackMessage} 
      handleClose={closeCreateJiraTicketPopup}
      isTestMode={isTestMode}
      selectedNamespace={selectedNamespace}
    />
  })



  const renderSidebarComponent = () => {
    switch (role) {
      case 'user':
        return <UserSideMenu navigate={navigate} location={location} openCreateJiraTicketPopup={openCreateJiraTicketPopup} handleOpenSnackMessage={handleOpenSnackMessage} />
      case 'admin':
        return <AdminSideMenus navigate={navigate} location={location} openCreateJiraTicketPopup={openCreateJiraTicketPopup} handleOpenSnackMessage={handleOpenSnackMessage} />
      case 'manager':
        return <ManagerSideMenus navigate={navigate} location={location} openCreateJiraTicketPopup={openCreateJiraTicketPopup} handleOpenSnackMessage={handleOpenSnackMessage} />

      default:
        return ""
    }
  }

  

  return (
    <Drawer variant="permanent" open={open} className={classes.sidebar} drawerwidth={drawerWidth}>
      <Box className={classes.sidebarTop} display='flex' flexDirection='column'>
        <img src={logoSrc} alt="sidebar-logo" />
        <Button
            variant="btn-primary-outlined"
            onClick={() => openCreateJiraTicketPopup()}
            text={isTestMode ? "Enter Domain URL" : "Enter JIRA Ticket Info" } 
          />
      </Box>
      <AlertDialog isOpenPopup={isOpenPopup} showCloseButton={Boolean(sideMenu?.length)} />
      {renderSidebarComponent()}
    </Drawer>)
}


Sidebar.propTypes = {
  open: propTypes.bool,
  toggleDrawer: propTypes.func,
  drawerWidth: propTypes.number,
  navigate: propTypes.func,
  location: propTypes.object,
  role: propTypes.string
};

// DefaultProps removed - using JavaScript default parameters instead